export default __webpack_public_path__ + "static/media/icons8_Logout 1.d4bfb447.svg";